import _ from 'lodash';
import Component from '../classes/component';

const SELECTORS = {
  searchInput: 'input#wpsl-search-input',
};

class StoreLocator extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private _setPlaceholderText(): void {
    const searchInput = this._getChild<HTMLInputElement>('searchInput');
    if (searchInput) {
      searchInput.placeholder = 'Entrez votre code postal';
    }
  }

  _onEnter(): void {
    this._setPlaceholderText();
  }
}

export default StoreLocator;
